import TableHeader from './table.js'

export {
  TableHeader,
}
